/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Solid_Background_OptionInputs */

const en_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solid Background`)
};

const fr_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fond solide`)
};

const de_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfarbiger Hintergrund`)
};

const it_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solido background`)
};

const ru_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сплошной фон`)
};

const es_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fondo sólido`)
};

const zh_cn2_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`纯色背景`)
};

const ja_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソリッド背景`)
};

const hi_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठोस पृष्ठभूमि`)
};

const pt_pt2_styles_solid_background_option = /** @type {(inputs: Styles_Solid_Background_OptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundo sólido`)
};

/**
* | output |
* | --- |
* | "Solid Background" |
*
* @param {Styles_Solid_Background_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_solid_background_option = /** @type {((inputs?: Styles_Solid_Background_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Solid_Background_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_solid_background_option(inputs)
	if (locale === "de") return de_styles_solid_background_option(inputs)
	if (locale === "it") return it_styles_solid_background_option(inputs)
	if (locale === "ru") return ru_styles_solid_background_option(inputs)
	if (locale === "es") return es_styles_solid_background_option(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_solid_background_option(inputs)
	if (locale === "ja") return ja_styles_solid_background_option(inputs)
	if (locale === "hi") return hi_styles_solid_background_option(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_solid_background_option(inputs)
	return en_styles_solid_background_option(inputs)
});